(function (W, D, $, Drupal) {
  /**
   * misc global scripts
   * @requires jQuery
   */

  'use strict'

  if (typeof W.sg === 'undefined') {
    W.sg = {}
  }

  let sg = W.sg, $D = $(D), contentHeight = '', heightActive = ''

  /*
   * misc utility methods
  */
  sg.utils = {

    $allMovingLine: $('.moving-line.moving-line-auto:not(.active)'),

    getNavigator: () => {
      const nAgt = navigator.userAgent;
      let browserName = navigator.appName;
      let fullVersion = '' + parseFloat(navigator.appVersion);
      let majorVersion = parseInt(navigator.appVersion, 10);
      let nameOffset, verOffset, ix;

      if ((verOffset = nAgt.indexOf("MSIE")) !== -1) {
        browserName = "IE";
        fullVersion = nAgt.substring(verOffset + 5);
      }
      else if ((verOffset = nAgt.indexOf("Trident")) !== -1) {
        // In IE, the true version is after "Trident" in userAgent
        browserName = "IE";
        fullVersion = nAgt.substring(verOffset + 5);
      }
      else if ((verOffset = nAgt.indexOf("Edge")) !== -1) {
        // In IE, the true version is after "Trident" in userAgent
        browserName = "edge";
        fullVersion = nAgt.substring(verOffset + 5);
      }
      else if ((verOffset = nAgt.indexOf("Chrome")) !== -1) {
        // In Chrome, the true version is after "Chrome"
        browserName = "chrome";
        fullVersion = nAgt.substring(verOffset + 7);
      }
      else if ((verOffset = nAgt.indexOf("Safari")) !== -1) {
        // In Safari, the true version is after "Safari" or after "Version"
        browserName = "safari";
        fullVersion = nAgt.substring(verOffset + 7);
        if ((verOffset = nAgt.indexOf("Version")) !== -1) {
          fullVersion = nAgt.substring(verOffset + 8);
        }
      }
      else if ((verOffset = nAgt.indexOf("Firefox")) !== -1) {
        // In Firefox, the true version is after "Firefox"
        browserName = "firefox";
        fullVersion = nAgt.substring(verOffset + 8);
      }
      else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {
        // In most other browsers, "name/version" is at the end of userAgent
        browserName = nAgt.substring(nameOffset, verOffset);
        fullVersion = nAgt.substring(verOffset + 1);
        if (browserName.toLowerCase() === browserName.toUpperCase()) {
          browserName = navigator.appName;
        }
      }
      // trim the fullVersion string at semicolon/space if present
      if ((ix = fullVersion.indexOf(";")) !== -1) {
        fullVersion = fullVersion.substring(0, ix);
      }
      if ((ix = fullVersion.indexOf(" ")) !== -1) {
        fullVersion = fullVersion.substring(0, ix);
      }

      majorVersion = parseInt('' + fullVersion, 10);
      if (isNaN(majorVersion)) {
        fullVersion = '' + parseFloat(navigator.appVersion);
        majorVersion = parseInt(navigator.appVersion, 10);
      }

      var oMod = {
        'browserName': browserName,
        'fullVersion': fullVersion,
        'majorVersion': majorVersion,
        'appName': navigator.appName,
        'userAgent': navigator.userAgent,
      }

      return oMod;
    },

    slugifyTag: (str, specificSpace) => {
      str = str.replace(/^\s+|\s+$/g, '') // trim
      str = str.toLowerCase()

      // remove accents
      let from = 'àáäâèéëêìíïîòóöôùúüûñç·/_,:;’\''
      let to = 'aaaaeeeeiiiioooouuuunc________'

      for (let i = 0, l = from.length; i < l; i++) { str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i)) }

      let defaultSpace = '_'
      if (typeof specificSpace !== 'undefined') {
        defaultSpace = specificSpace
      }

      str = str.replace(/^\s+|\s+$/g, '')
        .replace(/\./g, "") //remove dot (.)
        .replace(/(<([^>]+)>)/ig, "") //remove Html Tags
        .replace(/\s+/g, defaultSpace) // collapse whitespace and replace by _
        .replace(/-+/g, defaultSpace) // collapse dashes

      return str
    },

    getElmData: ($elm, sDataName) => {
      /**
       * return object containing $elm data-sDataName attribute
       */
      let reDataPairs = /([^=]+)=([^;]+);?/g
      let sData = $elm.attr('data-' + sDataName)

      if (!sData) {
        return null
      }

      let oData = {}
      let aParts = reDataPairs.exec(sData)

      while (aParts) {
        oData[decodeURIComponent(aParts[1])] = decodeURIComponent(aParts[2])
        aParts = reDataPairs.exec(sData)
      }

      return oData
    },

    stuckPopin: ($popin) => {
      if ($popin.length) {
        let tabbable = $popin.find('select, input, textarea, button, a').filter(':visible'),
          firstTabbable = tabbable.first(),
          lastTabbable = tabbable.last()

        /*set focus on first input*/
        firstTabbable.focus();
        /*redirect last tab to first input*/
        lastTabbable.on('keydown', function (e) {
          if ((e.which === 9 && !e.shiftKey)) {
            e.preventDefault()
            firstTabbable.focus()
          }
        });
        /*redirect first shift+tab to last input*/
        firstTabbable.on('keydown', function (e) {
          if ((e.which === 9 && e.shiftKey)) {
            e.preventDefault()
            lastTabbable.focus()
          }
        });
      }
    },

    toggleAriaExpanded: ($elm) => {
      let newAria = $elm.attr('aria-expanded') === 'true' ? 'false' : 'true'
      $elm.attr('aria-expanded', newAria)
    },

    toggleAriaHidden: ($elm) => {
      let newAria = $elm.attr('aria-hidden') === 'true' ? 'false' : 'true'
      $elm.attr('aria-hidden', newAria)
    },

    activeMovingLine: () => {
      sg.utils.$allMovingLine.map((i, el) => {
        let $movingLine = $(el)

        if ($movingLine.hasClass('active')) {
          return false;
        }
        if (sg.viewport.isElementInViewport($movingLine) && !$movingLine.hasClass('in-progress')) {
          $movingLine.addClass('in-progress')
          setTimeout(() => {
            $movingLine.addClass('active').removeClass('in-progress')
          }, 500);
        }
      })
    },

    progressBar: () => {
      let $progressBar = $('.progression-read')
      if ($progressBar.length > 0) {
        let scrollLevel = $(window).scrollTop(),
          widthProgression = Math.ceil((scrollLevel * 100) / heightActive)

        widthProgression = widthProgression >= 100 ? 100 : widthProgression
        $progressBar.css('width', widthProgression + '%').attr('aria-valuenow', widthProgression)
      }
    },
    openCookiePanel: () => {
      window.didomiOnReady = window.didomiOnReady || [];
      window.didomiOnReady.push(function (Didomi) {
        /**Link wysiwyg */
        $('.cookie-open-panel').on('click', function (e) {
          e.preventDefault()
          Didomi.preferences.show()
        })
      });
    },

    toggleFakeMultiselect: () => {
      $('.fake-multiselect').each(function () {
        const fakeMultiSelect = $(this);
        const checkboxes = fakeMultiSelect.find('input[type="checkbox"]');
        const countSpan = fakeMultiSelect.find('.fake-multiselect-count');

        const updateCount = () => {
          const checkedCount = checkboxes.filter(':checked').length;
          countSpan.text(checkedCount);

          if (checkedCount > 0) {
            countSpan.addClass('lg:flex').removeClass('lg:hidden');
          } else {
            countSpan.removeClass('lg:flex').addClass('lg:hidden');
          }
        };

        updateCount();

        fakeMultiSelect.find('.fake-multiselect-trigger').on('click', function (event) {
          event.stopPropagation();
          const isOpen = !fakeMultiSelect.find('.fieldset-wrapper').hasClass('lg:h-0');

          $('.fake-multiselect .fieldset-wrapper').addClass('lg:h-0 lg:overflow-hidden');
          $('.fake-multiselect').removeClass('lg:after:rotate-180');

          if (!isOpen) {
            fakeMultiSelect.find('.fieldset-wrapper').removeClass('lg:h-0 lg:overflow-hidden');
            fakeMultiSelect.addClass('lg:after:rotate-180');
          }
        });

        checkboxes.on('change', updateCount);
      });

      $(document).on('click', function (event) {
        if (!$(event.target).closest('.fake-multiselect').length) {
          $('.fake-multiselect .fieldset-wrapper').addClass('lg:h-0 lg:overflow-hidden');
          $('.fake-multiselect').removeClass('lg:after:rotate-180');
        }
      });
    },

    toggleExtendableList: () => {
      // Attacher le gestionnaire d'événements à un ancêtre commun
      $(document).on('click', '.js-extendable-list .js-extendable-list-trigger', function () {
        const extendableList = $(this).closest('.js-extendable-list');
        const extendableListItems = extendableList.find('.fieldset-wrapper');
        const extendableListTrigger = $(this);

        if (extendableListTrigger.hasClass('triggered')) {
          extendableListTrigger.removeClass('triggered');
          extendableListItems.addClass('max-h-[13.625rem]');
        } else {
          extendableListTrigger.addClass('triggered');
          extendableListItems.removeClass('max-h-[13.625rem]');
        }
      });
    }
  }

  sg.components = {
    //Acccordeon
    accordion: {
      init: ($aAccordionWrapper, delay = 500) => {
        let $button = $aAccordionWrapper.find('button.toggle-accordion')

        $(once('accordionClick', $button)).on('click', (e) => {
          let $btn = $(e.currentTarget),
            $content = $('#' + $btn.attr('aria-controls'))

          sg.utils.toggleAriaExpanded($btn)
          $content.slideToggle(delay)
        })
      }
    }
  }

  sg.polyfill = {
    customEvent: () => {
      if (typeof window.CustomEvent === "function") return false;

      function CustomEvent(event, params) {
        params = params || { bubbles: false, cancelable: false, detail: null };
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
      }

      window.CustomEvent = CustomEvent;
    }
  }

  $D.ready(() => {
    sg.polyfill.customEvent()

    contentHeight = $('.layout-container').outerHeight()
    heightActive = contentHeight - sg.viewport.height

    sg.utils.activeMovingLine()
    sg.utils.progressBar()

    /*Surcharge ajax-progress */
    Drupal.theme.ajaxProgressIndicatorFullscreen = function () {
      return '<div class="ajax-progress ajax-progress-fullscreen nj-spinner nj-spinner--sm" role="status"><span class="sr-only">Chargement...</span></div>';
    };
    if (typeof Drupal.Ajax !== 'undefined') {
      Drupal.Ajax.prototype.setProgressIndicatorFullscreen = function () {
        this.progress.element = $(Drupal.theme('ajaxProgressIndicatorFullscreen'));
        this.progress.element.removeClass('hide');
        $('body').after(this.progress.element);
      };
      Drupal.Ajax.prototype.setProgressIndicatorThrobber = function () {
        this.progress.element = $(Drupal.theme('ajaxProgressIndicatorFullscreen'));
        this.progress.element.removeClass('hide');
        $('body').after(this.progress.element);
      };
    }
    sg.utils.openCookiePanel()
    sg.utils.toggleFakeMultiselect()
    sg.utils.toggleExtendableList()
  })
  $(window).on('sg:viewport.scroll', () => {
    sg.utils.activeMovingLine()
    sg.utils.progressBar()
  })

})(window, document, window.jQuery, window.Drupal, once)
